(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_navigation-menu"] && !Shopify.designMode) return;
  try {
    // Drives the mobile accordion (aria-expanded on the chevron button) and
  // closes panels on Escape / outside click. Desktop opening is pure CSS (hover/focus).
  class NavMenu extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onDocClick = this._onDocClick.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);
      document.addEventListener('click', this._onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
    }
    _onClick(e) {
      const toggle = e.target.closest('.nav__toggle');
      if (!toggle || !this.contains(toggle)) return;
      e.preventDefault();
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    }
    _onKeydown(e) {
      if (e.key === 'Escape') {
        this._closeAll();
        const active = document.activeElement;
        if (active && this.contains(active) && typeof active.blur === 'function') {
          active.blur();
        }
      }
    }
    _onDocClick(e) {
      if (!this.contains(e.target)) this._closeAll();
    }
    _closeAll() {
      this.querySelectorAll('.nav__toggle[aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }
  }
  if (!customElements.get('nav-menu')) {
    customElements.define('nav-menu', NavMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["article-comments"] && !Shopify.designMode) return;
  try {
    // If a comment was just posted (success or error), bring the notice into view.
    // Scoped to this block's markup; runs once for the article-comments block type.
    (function () {
      function scrollToNotice() {
        var notice = document.querySelector('.article-comments__notice[data-posted]');
        if (notice) {
          notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      if (document.readyState !== 'loading') {
        scrollToNotice();
      } else {
        document.addEventListener('DOMContentLoaded', scrollToNotice);
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cart-upsell-group"] && !Shopify.designMode) return;
  try {
    (function () {
    // Standard Shopify money formatter, so the discounted price matches {{ ... | money }}.
    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || '${{amount}}';

      function withDelimiters(number, precision, thousands, decimal) {
        precision = (precision == null) ? 2 : precision;
        thousands = (thousands == null) ? ',' : thousands;
        decimal = (decimal == null) ? '.' : decimal;
        if (isNaN(number) || number == null) return '0';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? (decimal + parts[1]) : '';
        return dollars + centsPart;
      }

      var match = formatString.match(placeholderRegex);
      var placeholder = match ? match[1] : 'amount';
      var value;
      switch (placeholder) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
        default: value = withDelimiters(cents, 2);
      }
      return formatString.replace(placeholderRegex, value);
    }

    // Rewrite each upsell's price to show the visual discount. Idempotent: it always
    // recomputes from data-price (the server-rendered original), so re-running is safe.
    function applyCartUpsellDiscounts() {
      document.querySelectorAll('.cart-upsell-group[data-upsell-discount]').forEach(function (group) {
        var discount = parseFloat(group.getAttribute('data-upsell-discount'));
        if (!discount || discount <= 0) return;
        var format = group.getAttribute('data-money-format') || '';

        group.querySelectorAll('.cart-upsell .upsell-price[data-price]').forEach(function (priceEl) {
          var base = parseInt(priceEl.getAttribute('data-price'), 10);
          if (!base || isNaN(base)) return;
          var discounted = Math.round(base * (100 - discount) / 100);
          var label = (discount % 1 === 0) ? discount : discount.toFixed(1);

          priceEl.innerHTML =
            '<span class="final-price">' + formatMoney(discounted, format) + '</span>' +
            '<span class="compare-price">' + formatMoney(base, format) + '</span>' +
            '<span class="upsell-discount-badge">-' + label + '%</span>';
        });
      });
    }

    // Apply on load, then re-apply after every cart update (liquid-ajax-cart re-renders
    // the drawer and would otherwise revert prices to the originals).
    if (document.readyState !== 'loading') {
      applyCartUpsellDiscounts();
    } else {
      document.addEventListener('DOMContentLoaded', applyCartUpsellDiscounts);
    }
    document.addEventListener('liquid-ajax-cart:request-end', applyCartUpsellDiscounts);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["marquee"] && !Shopify.designMode) return;
  try {
    // <block-marquee> custom HTML Element
  class BlockMarquee extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('block-marquee', BlockMarquee);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slideshow"] && !Shopify.designMode) return;
  try {
    // <slideshow-component> custom HTML Element
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.nextSlide = this.nextSlide.bind(this);
      this.prevSlide = this.prevSlide.bind(this);
      this.intervalId = setInterval(this.nextSlide, 5000);

      this.slideIndex = 0;
    }
    connectedCallback() {
      if (this.hasChildNodes()) {
        this.querySelector('.slides').children[0].classList.add('active');
      }
      this.querySelector('.previous').addEventListener("click", this.prevSlide);
      this.querySelector('.next').addEventListener("click", this.nextSlide);
    }
    disconnectedCallback() {
      this.querySelector('.previous').removeEventListener("click", this.prevSlide);
      this.querySelector('.next').removeEventListener("click", this.nextSlide);
    }
    nextSlide() {
      clearInterval(this.intervalId);

      if (this.slideIndex == (this.querySelector('.slides').children.length - 1)) {
        this.slideIndex = 0;
      } else {
        this.slideIndex++;
      }
      for (let i = 0; i < this.querySelector('.slides').children.length; i++) {
        this.querySelector('.slides').children[i].classList.remove('active');
      }
      this.querySelector('.slides').children[this.slideIndex].classList.add('active');

      this.intervalId = setInterval(this.nextSlide, 5000);
    }
    prevSlide() {
      clearInterval(this.intervalId);

      if (this.slideIndex == 0) {
        this.slideIndex = this.querySelector('.slides').children.length - 1;
      } else {
        this.slideIndex--;
      }
      for (let i = 0; i < this.querySelector('.slides').children.length; i++) {
        this.querySelector('.slides').children[i].classList.remove('active');
      }
      this.querySelector('.slides').children[this.slideIndex].classList.add('active');

      this.intervalId = setInterval(this.nextSlide, 5000);
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    // <text-underline> custom HTML Element
  class TextUnderline extends HTMLElement {constructor() {super()}}
  customElements.define('text-underline', TextUnderline);

  // <text-accent> custom HTML Element
  class TextAccent extends HTMLElement {constructor() {super()}}
  customElements.define('text-accent', TextAccent);
  
  // <text-tag> custom HTML Element
  class TextTag extends HTMLElement {constructor() {super()}}
  customElements.define('text-tag', TextTag);

  // <timer-component> custom HTML Element
  class TimerComponent extends HTMLElement {
    static get observedAttributes() {
      return ['data-seconds'];
    }

    constructor() {
      super();
      this.remainingSeconds = 0;
      this.interval = null;
    }

    connectedCallback() {
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-seconds' && oldValue !== newValue) {
        this.start();
      }
    }

    start() {
      this.stop();

      const value = this.dataset.seconds;

      if (value === 'midnight') {
        this.remainingSeconds = this.secondsUntilMidnight();
      } else {
        this.remainingSeconds = parseInt(value, 10);
      }

      if (isNaN(this.remainingSeconds) || this.remainingSeconds < 0) return;

      this.render();

      this.interval = setInterval(() => {
        this.remainingSeconds--;

        if (this.remainingSeconds < 0) {
          this.stop();
          return;
        }

        this.render();
      }, 1000);
    }

    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    secondsUntilMidnight() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);

      console.log(midnight);

      return Math.floor((midnight - now) / 1000);
    }

    render() {
      const h = Math.floor(this.remainingSeconds / 3600);
      const m = Math.floor((this.remainingSeconds % 3600) / 60);
      const s = this.remainingSeconds % 60;

      this.innerHTML =
        `${String(h).padStart(2, '0')}:` +
        `${String(m).padStart(2, '0')}:` +
        `${String(s).padStart(2, '0')}`;
    }
  }

  customElements.define('timer-component', TimerComponent);
  } catch(e) { console.error(e); }
})();

})();
